import React from "react";
import assign from "lodash/assign";
import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import { Navigation, Link } from "react-router";
import { RaisedButton } from "material-ui";

import TicketSalesUnlocker from "../partials/ticket-sales-unlocker.jsx";
import InjectedTenantHTML from "../partials/injected-tenant-html.jsx";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../../stores/OrderStore";
import AppStore from "../../stores/AppStore";
import EventStore from "../../stores/EventStore";
import PersonStore from "../../stores/PersonStore";
import OrderActions from "../../actions/OrderActions";
import EventActions from "../../actions/EventActions";

export default statics(
  {
    willTransitionTo({ params, location: { query } }, replace, callback) {
      OrderActions.newCartOrderFlow();

      OrderActions.updateCurrentOrder({
        return: query.return
      });
      callback();
    },
    willTransitionAway() {}
  },

  @connectToStores
  class Overlay extends React.Component {
    constructor(props) {
      super(props);

      this.state = {};

      this.cancel = this.cancel.bind(this);
      this.submit = this.submit.bind(this);
    }

    static getStores() {
      return [AppStore, OrderStore, EventStore, PersonStore];
    }

    static getPropsFromStores() {
      var state = OrderStore.getState();
      (state.isKioskMode = AppStore.getState().isKioskMode),
        (state.kioskCode = AppStore.getState().kioskCode),
        (state.getOrderById = OrderStore.getOrderById);
      state.getEventById = EventStore.getEventById;
      state.getTicketBucketWithEventById =
        EventStore.getTicketBucketWithEventById;
      state.isLoggedIn = PersonStore.getState().isLoggedIn;
      state.person = PersonStore.getState().details;
      return state;
    }

    static get contextTypes() {
      return {
        router: React.PropTypes.object.isRequired,
        tenant: React.PropTypes.object
      };
    }

    componentWillReceiveProps(newProps) {
      if (this.state.hasSubmitted && newProps.completedOrderId) {
        OrderActions.updateCart.defer({ subitems: [] });
      }
    }

    cancel() {
      if (!(this.props.orderInProgress || this.props.orderSuccess)) {
        if (
          this.props.location.state &&
          this.props.location.state.fromListing
        ) {
          this.context.router.goBack();
        } else {
          this.context.router.push(`/schedule`);
        }
      }
    }

    submit() {
      this.setState({ hasSubmitted: true });
      OrderActions.submitOrder.defer();
    }

    render() {
      // Generate event details
      let eventsByTicketBucket = {};
      this.props.orderData.subitems.map(item => {
        if (item.ticket_bucket) {
          let bucket = this.props.getTicketBucketWithEventById(
            item.ticket_bucket
          );
          if (bucket) {
            eventsByTicketBucket[bucket.id] = bucket.event;
          }
        }
      });

      return (
        <BaseOverlay
          onRequestClose={this.cancel}
          className={this.props.className}
        >
          {this.props.orderData.subitems.length === 0 ? (
            <div
              style={{
                margin: "1em auto",
                textAlign: "center",
                fontSize: "12pt"
              }}
            >
              Nothing to check out&mdash;your cart is empty.
              <br />
              Why not{" "}
              <Link to="/schedule">
                explore the {this.context.tenant.display_schedule}?
              </Link>
            </div>
          ) : !this.state.wantsToUnlockSingleTickets &&
            this.props.appSettings.standalone_ticket_sales_locked &&
            !this.props.appSettings.user_standalone_ticket_sales_unlocked ? (
            <div style={{ padding: 20 }}>
              {this.context.tenant.standalone_ticket_sales_locked_error
                .__html ? (
                <InjectedTenantHTML
                  content={
                    this.context.tenant.standalone_ticket_sales_locked_error
                  }
                />
              ) : (
                this.context.tenant.standalone_ticket_sales_locked_error
              )}
              <div style={{ marginTop: 10 }}>
                <TicketSalesUnlocker />
              </div>
            </div>
          ) : (
            <Checkout
              orderInProgress={this.props.orderInProgress}
              orderSuccess={this.props.orderSuccess}
              orderErrorMessage={this.props.orderErrorMessage}
              orderData={this.props.orderData}
              orderSeatTimeout={this.props.orderSeatTimeout}
              updateCurrentOrder={data => {
                OrderActions.updateCurrentOrder(data);
                OrderActions.updateCart(data);
              }}
              completedOrder={this.props.getOrderById(
                this.props.completedOrderId
              )}
              person={this.props.person}
              isLoggedIn={this.props.isLoggedIn}
              initialCouponCode={this.props.location.query.discount_code}
              event={eventsByTicketBucket}
              isCartView={true}
              requiresUnlock={
                this.props.appSettings.standalone_ticket_sales_locked
              }
              isUnlocked={
                this.props.appSettings.user_standalone_ticket_sales_unlocked
              }
              cancel={this.cancel}
              submit={this.submit}
            />
          )}
        </BaseOverlay>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/cart.jsx